import type { ComponentProps, ForwardedRef, JSX } from 'react';

import { forwardRef } from '@change-corgi/core/react/core';
import { useOptionalId } from '@change-corgi/design-system/core';

import { BareInput } from './BareInput';
import { InputWrapper } from './components';

type Props = Omit<
	ComponentProps<typeof InputWrapper> & Omit<ComponentProps<typeof BareInput>, 'error'>,
	'errorId' | 'helperTextId'
>;

function InputInner(
	{ caption, error, helperText, id: idProp, label, hideLabel, size, ...rest }: Props,
	ref: ForwardedRef<HTMLInputElement>,
): JSX.Element {
	const id = useOptionalId(idProp);
	const errorId = `${id}___error`;
	const helperTextId = `${id}___helpertext`;

	return (
		<InputWrapper
			caption={caption}
			error={error}
			errorId={errorId}
			helperText={helperText}
			helperTextId={helperTextId}
			label={label}
			hideLabel={hideLabel}
			size={size}
		>
			<BareInput
				aria-describedby={`${helperTextId} ${errorId}`}
				error={error}
				id={id}
				ref={ref}
				size={size}
				{...rest}
			/>
		</InputWrapper>
	);
}

/**
 * @doc $DOC:Input
 */
export const Input = forwardRef(InputInner);
